import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Routes, Route } from 'react-router-dom';
// scripts and styles
import './index.css';
import NavigationScrollToTop from './scripts/NavigationScrollToTop.js'
// components
import App from './App';
import Home from './pages/Home';
import About from './pages/About';
import { Portfolio, PortfolioList } from './pages/Portfolio';
import RenamerFX from './pages/portfolio/RenamerFX';
import LinuxDesign from './pages/portfolio/LinuxDesign';
import LinuxExperience from './pages/portfolio/LinuxExperience';
import WebDev from './pages/portfolio/WebDev';
import { Writings, WritingList } from './pages/Writings';
import Computers from './pages/writings/Computers';
import Editors from './pages/writings/Editors';
import Gtk from './pages/writings/Gtk';
import Kde from './pages/writings/Kde';
import Kiina from './pages/writings/Kiina';
import Kubuntu from './pages/writings/Kubuntu';
import Lisp1 from './pages/writings/Lisp1';
import Lisp2 from './pages/writings/Lisp2';
import Ubuntu1 from './pages/writings/Ubuntu1';
import Ubuntu2 from './pages/writings/Ubuntu2';
import Java from './pages/writings/Java';


// Render the application's App.jsx to index.html that has <div id="root">
ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <NavigationScrollToTop>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="portfolio" element={<Portfolio />}>
              <Route index element={<PortfolioList />} />
              <Route path="renamerfx" element={<RenamerFX />} />
              <Route path="desktop-design" element={<LinuxDesign />} />
              <Route path="linux-experience" element={<LinuxExperience />} />
              <Route path="web-development" element={<WebDev />} />
            </Route>
            <Route path="writings" element={<Writings />}>
              <Route index element={<WritingList />} />
              <Route path="computers" element={<Computers />} />
              <Route path="editors" element={<Editors />} />
              <Route path="gtk" element={<Gtk />} />
              <Route path="java" element={<Java />} />
              <Route path="kde" element={<Kde />} />
              <Route path="kiina" element={<Kiina />} />
              <Route path="kubuntu" element={<Kubuntu />} />
              <Route path="lisp1" element={<Lisp1 />} />
              <Route path="lisp2" element={<Lisp2 />} />
              <Route path="ubuntu1" element={<Ubuntu1 />} />
              <Route path="ubuntu2" element={<Ubuntu2 />} />
            </Route>
          </Route>
        </Routes>
      </NavigationScrollToTop>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
